'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faInfoCircle } from '@icons/classic/regular';

import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';

import type { SizeProp } from '@fortawesome/fontawesome-svg-core';

export interface InfoTooltipProps {
  children?: React.ReactNode;
  size?: SizeProp;
  tooltip?: string;
}

export default function InfoTooltip({ children, tooltip, size = 'sm' }: InfoTooltipProps) {
  const tooltipContent = children || tooltip;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="text-[1rem]">
          <FontAwesomeIcon
            className="text-content-secondary"
            data-testid="info-tooltip-trigger"
            icon={faInfoCircle}
            size={size}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent onClick={(e) => e.stopPropagation()} width="xs">
        {tooltipContent}
      </TooltipContent>
    </Tooltip>
  );
}
